import * as React from 'react';
import MuiDivider from '@mui/material/Divider';

export const NavBarDivider = () => <MuiDivider orientation="vertical" variant="middle" flexItem={true} sx={{ bgcolor: 'secondary.contrastText' }} />;
